//import Vue from "vue";
import * as types from "./mtypes";

export default {
  //Get Accounts
  [types.FETCH_PERMISSIONS_REQUEST](state) {
    state.fetching = true;
    state.error = null;
  },

  [types.FETCH_PERMISSIONS_SUCCESS](state, result) {
    state.fetching = false;
    state.error = null;
    state.permissionList = result.data;
    state.totalRecords = result.totalRecords;
    state.pageSize = result.pageSize;
    state.currentPage = result.currentPage;
  },

  [types.FETCH_PERMISSIONS_FAILURE](state, error) {
    state.fetching = false;
    state.error = error;
    state.permissionList = [];
  },

  [types.FETCH_PERMISSIONS_APPS](state, result) {
    state.fetching = false;
    state.error = null;
    state.appList = result.data;
  },

  [types.REQUEST_HANDLER](state) {
    state.loading = true;
  },

  [types.REQUEST_SUCCESS](state, data) {
    state.loading = false;
    state.isSucceeded = data.succeeded;
    state.resultMessage = data.resultMessage;
  },

  [types.REQUEST_FAILURE](state, data) {
    state.loading = false;
    state.isSucceeded = data.Succeeded;
    state.errorCode = data.ErrorCode;
    state.errorMessage = data.ErrorMessage;
    state.validationErrors = data.ValidationErrors;
  },
};
